import React, {useEffect, useMemo, useState} from "react";
import CheckboxEditable from "./CheckboxEditable";
import { useFormContext } from "react-hook-form";

const CheckboxGroup = ({data}) => {

    const {watch} = useFormContext()

    const [optionsCount, setOptionsCount] = useState(1)

    useEffect(() => {
        const subscription = watch((value, { name, type }) =>{
            const currentLen = value.options.length
          if(name.includes('options') && currentLen === optionsCount && value.options[currentLen - 1].length) {
            setOptionsCount(optionsCount + 1)
          }
        })
        return () => subscription.unsubscribe()
      }, [watch, optionsCount])

    const options = useMemo(() => new Array(optionsCount).fill(''), [optionsCount])


    return (
        <div className="text-lavender font-medium">
            <p>Добавьте ниже варианты ответов и отметьте правильные:</p>
            <div className="mt-4 flex flex-col gap-1">
                {options.map((_, idx) => <CheckboxEditable idx={idx}  />)}
            </div>
        </div>
    )
}

export default CheckboxGroup